import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import ConsultationFilesPanel from '../pages/MedicalScribe/ConsultationFilesPanel';
import ConsultationWorkspaceHeader from '../pages/MedicalScribe/ConsultationWorkspaceHeader';
import ConsultationReportDialog from '../pages/MedicalScribe/ConsultationReportDialog';

const noop = () => {};
const source = { id: 'tour-practice-source', title: 'Reviewed consultation — example', type: 'Consultation', createdAt: '2026-01-08T10:00:00Z', isSelected: true };
const template = { id: 'tour-practice-template', title: 'Home practice' };
const card = { p: 2, bgcolor: '#FFFFFF', border: '1px solid #E5E7EB', borderRadius: '12px' };
const fileHandlers = Object.fromEntries([
  'deleteSelectedHistoryItems', 'handleDeleteItem', 'handleDownloadReport', 'handleMenuClose',
  'handlePatientFileUpload', 'setAlert', 'setOpenDialog', 'setPreviewItem', 'setPreviewOpen',
  'setSearchQuery', 'setShowPastDocs', 'toggleItemSelection',
].map(name => [name, noop]));

// Presentation only: never mount the live generation/template-seeding hooks.
export default function HomePracticeTourPreview({ screen }) {
  if (screen === 'home-practice-complete') return <Box data-tour="demo-home-practice-complete" sx={{ ...card, mt: 2 }}>
    <Typography variant="h6">MindVault → Chat → Practice</Typography>
    <Typography sx={{ mt: 1 }}>The connected client uses Practice after the reviewed report is shared and the existing sharing requirements are met.</Typography>
    <Typography color="text.secondary" sx={{ mt: 1 }}>Example only. No MindVault setting, exercise or notification is created by this walkthrough.</Typography>
  </Box>;

  return <Box inert="" sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: 2, mt: 2 }}>
    <Box data-tour="demo-report-sources">
      <ConsultationFilesPanel {...fileHandlers} readOnly showPastDocs leftPanelWidth={280}
        anchorEl={null} consultationLoading={false} convertToGMT8Date={() => 'Jan 8, 2026'}
        editingConsultationId={null} fileInputRef={{ current: { click: noop } }}
        getFilteredHistoryItems={() => [source]} isSupportedTranscriptionFile={() => false}
        searchQuery="" selectedItem={null} selectedItems={[source]}
        sortConfig={{ key: 'createdAt', direction: 'desc' }} workflowMode="write-document" />
    </Box>
    <Stack spacing={2} sx={{ flex: 1, minWidth: 0 }}>
      <Box data-tour="demo-home-practice-shortcut" sx={card}>
        <ConsultationWorkspaceHeader title="Reviewed consultation — example" sourceLabel="1 reviewed source selected"
          canGenerateReport onGenerateHomework={noop} />
      </Box>
      {screen === 'home-practice-setup' && <Box data-tour="demo-home-practice-setup" sx={card}>
        <ConsultationReportDialog open inline readOnly canGenerate isGenerating={false}
          onClose={noop} onGenerate={noop} onSelectTemplate={noop} onUploadTemplate={noop}
          selectedTemplate={template} templates={[template]} sourceLabel="Reviewed consultation — example"
          reportDate="2026-01-08" onReportDateChange={noop} />
      </Box>}
      {screen === 'home-practice-result' ? <Box data-tour="demo-home-practice-result" sx={card}>
        <Typography variant="h6">Home practice handout — example</Typography>
        <Typography fontWeight={600} sx={{ mt: 2 }}>Practice 1: Prepare a discussion note</Typography>
        <Typography sx={{ mt: 1 }}>1. Write one sentence about a situation you would like to discuss.</Typography>
        <Typography>2. Bring the note to your next meeting.</Typography>
        <Typography color="text.secondary" sx={{ mt: 2 }}>This matches the fictional agreed assignment. In the real workflow, review and edit the entire handout before sharing.</Typography>
      </Box> : <Box data-tour="demo-home-practice-source" sx={card}>
        <Typography variant="h6">Reviewed source — fictional assignment</Typography>
        <Typography sx={{ mt: 1 }}>Clinician: Before our next meeting, write one sentence about a situation you would like to discuss. Bring the note to the meeting.</Typography>
        <Typography sx={{ mt: 1 }}>Jordan: Agreed.</Typography>
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 2 }}>Sample only — not a recommendation for a real client.</Typography>
      </Box>}
    </Stack>
  </Box>;
}
